// Update channel fields (name, topic, is_private). Owner-only at the RLS
// layer. Returns the patched channel object, or null on failure.
import { getSDK } from '../sdk.js'
import { rowToChannel } from './chatUtils.js'

export const updateChannel = async function (channelId, patch) {
  const root = this.state.root
  if (!channelId || !patch) return null
  const updates = {}
  if (patch.name !== undefined) updates.name = patch.name
  if (patch.topic !== undefined) updates.topic = patch.topic
  if (patch.is_private !== undefined) updates.is_private = patch.is_private
  if (patch.is_archived !== undefined) updates.is_archived = patch.is_archived
  try {
    // migrated 2026-04-27 to SDK route workspaceProject.chat update
    const result = await getSDK().execute('workspaceProject.chat', 'update', {
      id: channelId,
      payload: updates
    })
    const ch = rowToChannel(result?.data || result)
    const next = (root.channels || []).map(c => c.id === channelId ? ch : c)
    root.update({ channels: next })
    return ch
  } catch (err) {
    console.error('[updateChannel]', err)
    return null
  }
}

export const archiveChannel = async function (channelId) {
  return updateChannel.call(this, channelId, { is_archived: true })
}
